import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DialogResult } from '../services/dialog.service';

@Component({
  selector: 'app-dialog-base',
  standalone: true,
  imports: [],
  template: '',
  styles: []
})
export class DialogBaseComponent {
  @Input() options?: any;
  @Output() completeEvent = new EventEmitter<DialogResult<unknown>>();
  isClosing = false;

  setIsClosing(closing: boolean) {
    this.isClosing = closing;
  }

  complete(value?: unknown) {
    this.completeEvent.emit({
      isSubmitted: true,
      isCancelled: false,
      isDismissed: false,
      value: value
    });
  }

  cancel() {
    this.completeEvent.emit({
      isSubmitted: false,
      isCancelled: true,
      isDismissed: false
    });
    return false;
  }

  dismiss() {
    this.completeEvent.emit({
      isSubmitted: false,
      isCancelled: false,
      isDismissed: true
    });
    return false;
  }
}
